var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"636px","height":"560px"},attrs:{"id":"radarChart"}})}
var staticRenderFns = []

export { render, staticRenderFns }